import { useContext } from 'react'
import { TrueClaimContext } from '../context/TrueClaimContext'

export const useTrueClaim = () => useContext(TrueClaimContext)
